module.exports = __webpack_public_path__ + "img/hero-player-mobile.6e646e5d.png";